import { BellOff, TriangleAlert } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface NotificationDeniedModalProps {
  open: boolean;
  onDismiss: () => void;
}

export const NotificationDeniedModal: React.FC<NotificationDeniedModalProps> = ({
  open,
  onDismiss,
}) => {
  const { t } = useTranslation('authenticated.notifications');

  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && onDismiss()}>
      <DialogContent className="max-w-[560px] border-none outline-none">
        <DialogHeader className="space-y-4">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
            <BellOff className="h-6 w-6 text-destructive" />
          </div>
          <DialogTitle className="text-center">{t('deniedModal.title')}</DialogTitle>
          <DialogDescription className="whitespace-pre-line text-center">
            <Trans
              i18nKey="authenticated.notifications:deniedModal.description"
              components={{ bold: <strong /> }}
            />
          </DialogDescription>
        </DialogHeader>

        <Alert variant="warning">
          <TriangleAlert className="h-4 w-4" />
          <AlertDescription className="text-xs">
            <Trans
              i18nKey="authenticated.notifications:deniedModal.howToEnable"
              components={{ bold: <strong /> }}
            />
          </AlertDescription>
        </Alert>

        <DialogFooter className="mt-2 sm:justify-center">
          <Button onClick={onDismiss}>{t('deniedModal.dismiss')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
